import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=7c0173b6&scoped=true&"
import script from "./Incident.vue?vue&type=script&lang=js&"
export * from "./Incident.vue?vue&type=script&lang=js&"
import style0 from "./Incident.vue?vue&type=style&index=0&id=7c0173b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0173b6",
  null
  
)

export default component.exports